"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ResponseException = exports.IdNotMatchException = void 0;
var _ErrorCode = _interopRequireDefault(require("./ErrorCode"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
class IdNotMatchException extends Error {
  constructor(requestId, responseId) {
    super(`Expect json rpc id to be ${requestId}, but ${responseId} received`);
    _defineProperty(this, "code", _ErrorCode.default.IdNotMatch);
  }
}
exports.IdNotMatchException = IdNotMatchException;
class ResponseException extends Error {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "code", _ErrorCode.default.ResponseMessage);
  }
}
exports.ResponseException = ResponseException;
var _default = {
  IdNotMatchException,
  ResponseException
};
exports.default = _default;
//# sourceMappingURL=rpc.js.map